var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg02679IconServiceTenantProperties(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a9989f71-256c-4730-b8b2-338bdf8b225d",
    x1: 11.972,
    y1: 14.787,
    x2: 11.972,
    y2: 2.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#32bedd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#32ceef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32d4f5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f83db80a-8520-456c-b61e-9e921002b652",
    x1: 4.699,
    y1: 15.352,
    x2: 4.699,
    y2: 3.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1988d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#54aef0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b6736b87-a21d-4e07-a3c8-cb29b97c0ed8",
    x1: 1.31,
    y1: 15.346,
    x2: 1.31,
    y2: 3.839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#005ba1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a0e1a530-7e93-4cbb-bb24-d77349ee094b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17.975,9.225V8.269a.3.3,0,0,0-.192-.277h0l-1.335-.438a.3.3,0,0,1-.182-.169L15.983,6.7a.3.3,0,0,1,.006-.238l.6-1.279a.3.3,0,0,0-.059-.335l-.662-.663a.3.3,0,0,0-.342-.055h0l-1.248.635a.294.294,0,0,1-.246.01l-.69-.283a.3.3,0,0,1-.166-.173l-.485-1.338a.3.3,0,0,0-.278-.195h-.956a.3.3,0,0,0-.277.192h0l-.438,1.335a.3.3,0,0,1-.169.181l-.688.283a.3.3,0,0,1-.24-.007l-1.254-.6a.3.3,0,0,0-.336.058l-.662.662a.3.3,0,0,0-.056.342h0l.635,1.247a.3.3,0,0,1,.01.247L7.7,7.414a.3.3,0,0,1-.174.166l-1.36.486a.3.3,0,0,0-.2.279V9.3a.3.3,0,0,0,.193.277h0l1.334.437a.3.3,0,0,1,.182.169l.283.69a.3.3,0,0,1-.006.238l-.6,1.279a.3.3,0,0,0,.059.335l.663.663a.3.3,0,0,0,.341.055h0l1.247-.635a.3.3,0,0,1,.247-.01l.689.283a.289.289,0,0,1,.166.173l.485,1.338a.3.3,0,0,0,.279.2h.955a.3.3,0,0,0,.278-.192h0L13.2,13.26a.294.294,0,0,1,.169-.181l.69-.283a.29.29,0,0,1,.238.006l1.279.6a.3.3,0,0,0,.335-.058l.663-.663a.3.3,0,0,0,.055-.342h0L16,11.09a.294.294,0,0,1-.01-.246l.282-.69a.3.3,0,0,1,.173-.166L17.78,9.5A.3.3,0,0,0,17.975,9.225ZM12.24,11.406a2.635,2.635,0,1,1,2.354-2.353A2.635,2.635,0,0,1,12.24,11.406Z",
    fill: "url(#a9989f71-256c-4730-b8b2-338bdf8b225d)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M.049,3.85.954,2.8a.441.441,0,0,1,.332-.151H9.964a.608.608,0,0,1,.664.621V14.041a.24.24,0,0,1-.083.182L9.282,15.316H.636l-.6-.252Z",
    fill: "#005ba1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.777,3.846l.555-.633a.392.392,0,0,1,.294-.133h8.1a.39.39,0,0,1,.39.39v10.3a.391.391,0,0,1-.127.289l-.866.788Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.139,3.839H.1A.058.058,0,0,0,.036,3.9V15.13a.222.222,0,0,0,.222.222H9.139a.223.223,0,0,0,.223-.222V4.061A.222.222,0,0,0,9.139,3.839Z",
    fill: "url(#f83db80a-8520-456c-b61e-9e921002b652)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.071,3.839H2.594a0,0,0,0,1,0,0V15.346a0,0,0,0,1,0,0H.213a.188.188,0,0,1-.188-.188V3.885A.046.046,0,0,1,.071,3.839Z",
    fill: "url(#b6736b87-a21d-4e07-a3c8-cb29b97c0ed8)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02679IconServiceTenantProperties);
export default __webpack_public_path__ + "static/media/02679-icon-service-Tenant-Properties.95ea16131ca8cde7e1d18f1c5ef644b6.svg";
export { ForwardRef as ReactComponent };